import { Route, Routes } from "react-router-dom"

import { RiskZonesSidebarRouter } from "../../../modules/riskZones/routers/RiskZonesSidebarRouter"
import { SpeedingsSidebarRouter } from "../../../modules/speedings/routers/SpeedingsSidebarRouter"
import { MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "../../constants/modules"

export const SidebarRouter = () => {

    return <Routes>
        <Route
            element={<RiskZonesSidebarRouter />}
            path={`/${MODULE_RISK_ZONES}/*`}
        />
        <Route
            element={<SpeedingsSidebarRouter />}
            path={`/${MODULE_SPEEDINGS}/*`}
        />
    </Routes>
}